import QuinceNova from "./QuinceNova";
import { datosEjemplo } from "./sampleData";
import { paletas } from "./paletas";

export const definicion = {
  id: "quince-nova",
  tipoEvento: "quince",
  tipoEtiqueta: "15 años",
  nombre: "Nova",
  descripcion:
    "Noche glamurosa a pantalla completa: foto con scrim cinematográfico, numeral XV gigante de fondo y tipografía condensada en mayúsculas. Tema oscuro con acentos dorados.",
  miniatura: datosEjemplo.fotos.portada,
  miniaturas: {
    medianoche: "/miniaturas/quince-nova-medianoche.jpg",
    vino: "/miniaturas/quince-nova-vino.jpg",
    esmeralda: "/miniaturas/quince-nova-esmeralda.jpg",
  },
  paletas,
  datosEjemplo,
  Componente: QuinceNova,
};
